module.exports = __webpack_public_path__ + "61875030b205f06a440e0e642480cfa4.png";